import { useUpdateFormData, useSetStarted } from "@/stores"; // Use new store hooks
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function FirstStepForm() {
  const navigate = useNavigate();
  const updateFormData = useUpdateFormData();
  const setStarted = useSetStarted();

  // Local state to track the selected property type
  const [selectedPropertyType, setSelectedPropertyType] = useState("");

  const propertyTypes = [
    {
      label: "Wohnung",
      icon: "/Icons/Abfrage/abfrage-immobilienart-wohnung.svg",
    },
    { label: "Haus", icon: "/Icons/Abfrage/abfrage-immobilienart-haus.svg" },
    {
      label: "Gewerbe",
      icon: "/Icons/Abfrage/abfrage-immobilienart-gewerbe.svg",
    },
    {
      label: "Grundstück",
      icon: "/Icons/Abfrage/abfrage-immobilienart-grundstuck.svg",
    },
  ];

  // When a user selects a property type:
  const handleSelect = (propertyLabel) => {
    setSelectedPropertyType(propertyLabel);

    // Update new store
    setStarted(true);
    updateFormData({ propertyType: propertyLabel });

    // Determine next step and navigate
    if (propertyLabel === "Wohnung") {
      // Skip sub-type for Wohnung (if that's the logic) or go to next relevant step
      // Based on new formSteps, step 2 is sub-type (conditional)
      // Step 3 is property-size.
      // But let's check formSteps config:
      // Step 1: property-type
      // Step 2: sub-type (skip if Wohnung)
      // So for Wohnung, next is property-size (step 3 logic in old form, but ID based in new)
      // ID: "property-size"
      navigate("/bewerten/immobilie/online-bewertung?step=property-size");
      return;
    }

    // For others, go to sub-type
    navigate("/bewerten/immobilie/online-bewertung?step=sub-type");
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <h2 className="text-white font-serif font-medium pb-10 text-center md:text-4xl text-2xl">
        Welche Immobilie möchten Sie bewerten?
      </h2>

      <div className="grid justify-center items-center grid-cols-2 gap-2 py-5 w-full sm:w-fit">
        {propertyTypes.map((property) => (
          <label
            key={property.label}
            onClick={() => handleSelect(property.label)}
            className={`group rounded-xl w-full flex flex-col sm:h-auto items-center 
              justify-center  sm:gap-0 p-4 aspect-video 
              min-[750px]:w-[20rem] cursor-pointer text-center transition-all
              ${
                selectedPropertyType === property.label
                  ? "border-none bg-prime-800/90 ring-2 ring-prime-600 scale-[1.0] text-gray-200"
                  : "bg-prime-50 hover:bg-prime-200/80 border-gray-200 text-prime-950"
              }`}
          >
            {/* Radio input: hidden, but helps manage the “checked” state */}
            <input
              type="radio"
              name="propertyType"
              value={property.label}
              checked={selectedPropertyType === property.label}
              readOnly
              className="hidden"
            />
            {property.icon && (
              <img
                src={property.icon}
                alt={property.label}
                className="w-12 h-12 md:w-16 md:h-16 md:mx-auto"
              />
            )}
            <span className="mt-2 block font-medium md:text-lg">
              {property.label}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}
